import { useState } from "react";
import { Route, Routes } from "react-router-dom";

import AboutUs from "pages/AboutUs";
import Home from "pages/Home";
import Methodology from "pages/Methodology";
import Contact from "pages/Contact";
import Calculator from "pages/Calculator";
import Result from "pages/Result";
import TermsAndConditions from "pages/TermsAndConditions";
import FAQ from "pages/FAQ";
import CaseStudies from "pages/CaseStudies";

import Navbar from "components/Navbar";
import Sidebar from "components/Sidebar";

import "./App.scss";

function App() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    //July 2026 Deployment Pipeline Fix - repo url fix
    return (
        <div className="app-container">
            <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/methodology" element={<Methodology />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/results/:id" element={<Result />} />
            </Routes>
        </div>
    );
}

export default App;
